// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__28qwW","label":"LabeledBox_label__JUgc3"};